import React, { useEffect, useRef, useState } from 'react';

// Windowed <tbody>: mounts its rows only while near the viewport, otherwise a same-height spacer.
export const VirtualRowGroup = ({ eager = false, colSpan, estimatedHeight = 96, children, testId }) => {
  const ref = useRef(null);
  const heightRef = useRef(estimatedHeight);
  const [near, setNear] = useState(eager);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') { setNear(true); return undefined; }
    const io = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting && ref.current) {
        const h = ref.current.getBoundingClientRect().height;
        if (h > 0) heightRef.current = h;
      }
      setNear(entry.isIntersecting);
    }, { rootMargin: '900px 0px' });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const show = near || eager;
  return (
    <tbody ref={ref} data-testid={testId} data-virtual={show ? 'mounted' : 'spacer'}>
      {show ? children : (
        <tr aria-hidden="true" style={{ height: heightRef.current }}><td colSpan={colSpan} /></tr>
      )}
    </tbody>
  );
};
